///
/// EarthBrowser
///
/// Migration v7 to v8: Convert satelliteRequestParams to selectedSatelliteGroupId
///
/// This migration changes the satellite configuration from API-based params
/// to a simple group ID for database-based satellite loading.
///

interface StateV7 {
	earthbrowser?: {
		satelliteRequestParams?: {
			group_id?: string
		}
	}
}

/**
 * Migration from version 7 to 8: Convert satellite request params to group ID
 * - Extracts group_id from satelliteRequestParams
 * - Creates selectedSatelliteGroupId with that value (defaults to "visual")
 * - Removes the old satelliteRequestParams field
 *
 * Note: Redux freezes state objects, so we must return a new object rather than mutate
 */
export function migrateV7toV8(state: unknown): unknown {
	if (!state) {
		return state
	}

	const s = state as StateV7
	const oldEarthbrowser = s.earthbrowser || {}

	// Extract group_id from old satelliteRequestParams if it exists
	const oldParams = oldEarthbrowser.satelliteRequestParams
	const groupId = oldParams?.group_id ?? "visual"

	// Create new earthbrowser state with selectedSatelliteGroupId
	// and without satelliteRequestParams
	const restEarthbrowser = { ...oldEarthbrowser }
	delete restEarthbrowser.satelliteRequestParams

	const newEarthbrowser = {
		...restEarthbrowser,
		selectedSatelliteGroupId: groupId
	}

	// Return completely new state object
	return {
		...s,
		earthbrowser: newEarthbrowser
	}
}
